import React, { Suspense, useEffect, useState } from 'react'
import { HashRouter, Route, Switch } from 'react-router-dom'
import styled from 'styled-components'
import { Credentials, StringTranslations } from '@crowdin/crowdin-api-client'
import Popups from '../components/Popups'
import Web3ReactManager from '../components/Web3ReactManager'
import { RedirectDuplicateTokenIds, RedirectOldAddLiquidityPathStructure } from './AddLiquidity/redirects'
import { RedirectOldRemoveLiquidityPathStructure } from './RemoveLiquidity/redirects'
import AddLiquidity from './AddLiquidity'
import Pool from './Pool'
import PoolFinder from './PoolFinder'
import RemoveLiquidity from './RemoveLiquidity'
import Swap from './Swap'
import { RedirectPathToSwapOnly } from './Swap/redirects'
import { EN, allLanguages } from '../constants/localisation/languageCodes'
import { LanguageContext } from '../hooks/LanguageContext'
import { TranslationsContext } from '../hooks/TranslationsContext'

import Menu from '../components/Menu'

const AppWrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  overflow-x: hidden;
`

const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 32px 16px;
  align-items: center;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 1;
  justify-content: center;
  // background-image: url('/images/group-pancake.svg');
  background-repeat: no-repeat;
  background-position: bottom 24px center;
  background-size: 90%;

  ${({ theme }) => theme.mediaQueries.xs} {
    background-size: auto;
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    // background-image: url('/images/arch-${({ theme }) => (theme.isDark ? 'dark' : 'light')}.svg'),
    //   url('/images/left-pancake.svg'), url('/images/right-pancake.svg');
    background-repeat: no-repeat;
    background-position: center 420px, 10% 230px, 90% 230px;
    background-size: contain, 266px, 266px;
    min-height: 90vh;
  }
`

const Marginer = styled.div`
  margin-top: 5rem;
`

export default function App() {
  const [selectedLanguage, setSelectedLanguage] = useState<any>(undefined)
  const [translatedLanguage, setTranslatedLanguage] = useState<any>(undefined)
  const [translations, setTranslations] = useState<Array<any>>([])
  const apiKey = `${process.env.REACT_APP_CROWDIN_APIKEY}`
  const projectId = parseInt(`${process.env.REACT_APP_CROWDIN_PROJECTID}`)
  const fileId = 6
  const credentials: Credentials = {
    token: apiKey,
  }

  const stringTranslationsApi = new StringTranslations(credentials)

  const getStoredLang = (storedLangCode: string) => {
    return allLanguages.filter((language) => {
      return language.code === storedLangCode
    })[0]
  }

  // useEffect(() => {
  //   const storedLangCode = localStorage.getItem('pancakeSwapLanguage')
  //   if (storedLangCode) {
  //     const storedLang = getStoredLang(storedLangCode)
  //     setSelectedLanguage(storedLang)
  //   } else {
  //     setSelectedLanguage(EN)
  //   }
  // }, [])

  const fetchTranslationsForSelectedLanguage = async () => {
    stringTranslationsApi
      .listLanguageTranslations(projectId, selectedLanguage.code, undefined, fileId, 200)
      .then((translationApiResponse) => {
        if (translationApiResponse.data.length < 1) {
          setTranslations(['error'])
        } else {
          setTranslations(translationApiResponse.data)
        }
      })
      .then(() => setTranslatedLanguage(selectedLanguage))
      .catch((error) => {
        setTranslations(['error'])
        console.error(error)
      })
  }

  // useEffect(() => {
  //   if (selectedLanguage) {
  //     fetchTranslationsForSelectedLanguage()
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [selectedLanguage])


  useEffect(() => {
    const handleWheel = (e) => {
      if (e.ctrlKey || e.metaKey) {
        e.preventDefault();
      }
    };

    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && (e.key === '+' || e.key === '-'|| e.key==='=')) {
        e.preventDefault();
      }
    };

    // Add event listeners when the component mounts
    window.addEventListener('wheel', handleWheel);
    window.addEventListener('keydown', handleKeyDown);

    // Clean up by removing event listeners when the component unmounts
    return () => {
      window.removeEventListener('wheel', handleWheel);
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <Suspense fallback={null}>
      <HashRouter>
        <AppWrapper>
          {/* <LanguageContext.Provider
            value={{ selectedLanguage, setSelectedLanguage, translatedLanguage, setTranslatedLanguage }}
          > */}
            {/* <TranslationsContext.Provider value={{ translations, setTranslations }}> */}
              <Menu>
                <BodyWrapper>
                  <Popups />
                  <Web3ReactManager>
                    <Switch>
                      <Route exact strict path="/swap" component={Swap} />
                      <Route exact strict path="/find" component={PoolFinder} />
                      <Route exact strict path="/pool" component={Pool} />
                      <Route exact path="/add" component={AddLiquidity} />
                      <Route exact strict path="/remove/:currencyIdA/:currencyIdB" component={RemoveLiquidity} />

                      {/* Redirection: These old routes are still used in the code base */}
                      <Route exact path="/add/:currencyIdA" component={RedirectOldAddLiquidityPathStructure} />
                      <Route exact path="/add/:currencyIdA/:currencyIdB" component={RedirectDuplicateTokenIds} />
                      <Route exact strict path="/remove/:tokens" component={RedirectOldRemoveLiquidityPathStructure} />

                      <Route component={RedirectPathToSwapOnly} />
                      
                    </Switch>
                  </Web3ReactManager>
                  
                  <Marginer />
                 
                </BodyWrapper>
              </Menu>

            {/* </TranslationsContext.Provider> */}
          {/* </LanguageContext.Provider> */}
        </AppWrapper>
        <br />
        <footer style={{position:'fixed', bottom:'0', textAlign:'center', width:'100%', margin:'0 auto', display:'block' }}>

    <svg width="100%" height="2" viewBox="0 0 1178 2" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 1.00012L1178 1.00002" stroke="white" strokeOpacity="0.2"/>
</svg>  
                    <div className='row'>
                      {/* <div className='col-12 col-md-12' style={{textAlign:'center'}}>
                      <img src="/images/footer.svg" style={{width:'100%', maxWidth:'197px'}} alt="footer logo" />


                      </div> */}
 
                      <div className='col-12 col-md-12' style={{padding:'5px', textAlign:'center'}}>
                        {/* <a href="/" style={{marginLeft:'1rem'}}>
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="40" height="40" rx="20" fill="#D9D9D9" fillOpacity="0.14"/>
<path d="M21.1008 28.739C21.1871 28.7392 21.2726 28.763 21.3523 28.8091C21.432 28.8551 21.5044 28.9226 21.5654 29.0076C21.6263 29.0926 21.6746 29.1934 21.7076 29.3043C21.7405 29.4153 21.7574 29.5341 21.7573 29.6541C21.7571 29.7741 21.74 29.8929 21.7069 30.0037C21.6737 30.1145 21.6252 30.2152 21.564 30.2999C21.5029 30.3847 21.4304 30.4518 21.3506 30.4976C21.2708 30.5434 21.1853 30.5668 21.0989 30.5667C20.9246 30.5663 20.7575 30.4697 20.6344 30.2981C20.5112 30.1265 20.4422 29.8939 20.4425 29.6515C20.4427 29.4092 20.5122 29.1769 20.6357 29.0057C20.7591 28.8346 20.9264 28.7387 21.1008 28.739ZM31.4096 23.0884C31.3232 23.0883 31.2377 23.0646 31.158 23.0186C31.0783 22.9726 31.0058 22.9052 30.9448 22.8203C30.8838 22.7353 30.8355 22.6346 30.8025 22.5237C30.7695 22.4128 30.7526 22.2939 30.7526 22.1739C30.7527 22.0539 30.7698 21.9351 30.8028 21.8242C30.8359 21.7134 30.8844 21.6127 30.9455 21.5279C31.0066 21.4431 31.0791 21.3759 31.1589 21.33C31.2387 21.2842 31.3242 21.2606 31.4105 21.2607C31.5848 21.2609 31.752 21.3573 31.8752 21.5288C31.9984 21.7003 32.0675 21.9328 32.0674 22.1752C32.0673 22.4176 31.9979 22.6499 31.8745 22.8212C31.7512 22.9924 31.5839 23.0886 31.4096 23.0884ZM31.4096 19.3499C30.8705 19.3506 30.3537 19.6485 29.9726 20.1784C29.5914 20.7082 29.3771 21.4266 29.3766 22.1759C29.3766 22.4787 29.4131 22.7803 29.4841 23.0741L22.7691 28.0436C22.5829 27.6678 22.3337 27.3605 22.0431 27.1483C21.7525 26.9361 21.4291 26.8254 21.1008 26.8256C20.3256 26.8256 19.6196 27.443 19.2773 28.4062L13.2449 23.984C12.6071 23.5186 12.1302 22.0602 12.1807 20.7317C12.2069 20.0388 12.3789 19.5007 12.6417 19.2927C12.8082 19.1627 13.0083 19.1731 13.2215 19.3278L13.2608 19.3577C14.8598 20.5276 20.0909 24.3584 20.3116 24.5001C20.651 24.7197 20.8399 24.8081 21.4197 24.426L32.2334 16.6084C32.3924 16.5252 32.5775 16.3133 32.5775 15.9923C32.5775 15.5477 32.2465 15.3722 32.2455 15.3722C31.6302 14.9628 30.6848 14.3479 29.7628 13.7474C27.7916 12.4644 25.5576 11.0111 24.5766 10.2961C23.7294 9.67999 23.0477 10.1999 22.9261 10.3039L22.6905 10.4664C18.2749 13.5017 12.3649 17.5703 12.0283 17.855C11.427 18.3646 11.0539 19.3798 11.0053 20.6394C10.9304 22.6373 11.6626 24.721 12.7109 25.4841L19.0903 30.0571C19.1606 30.7289 19.4024 31.343 19.7715 31.7874C20.1406 32.2318 20.6125 32.4768 21.1008 32.4775C21.6341 32.4762 22.1458 32.1841 22.5258 31.6639C22.9058 31.1437 23.1237 30.437 23.1328 29.6957L30.1593 24.4013C30.5146 24.7886 30.957 25.0005 31.4096 25.0005C31.9486 24.9998 32.4654 24.7019 32.8465 24.1721C33.2277 23.6422 33.442 22.9238 33.4425 22.1746C33.442 21.4253 33.2277 20.7069 32.8465 20.1771C32.4654 19.6472 31.9486 19.3493 31.4096 19.3486" fill="white"/>
</svg>

                        </a> */}
                        <a href="https://X.com/PondArtChain" target='_blank' rel="noreferrer" style={{marginLeft:'1rem'}}>
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect y="0.00012207" width="40" height="40" rx="20" fill="#D9D9D9" fillOpacity="0.14"/>
<g filter="url(#filter0_d_249_388)">
<path fillRule="evenodd" clipRule="evenodd" d="M17.7431 20.5122L11 12.0001H16.341L20.5035 17.2612L24.9504 12.0238H27.8919L21.9257 19.0588L29 28.0001H23.675L19.1678 22.3106L14.3561 27.9844H11.3986L17.7431 20.5122ZM24.4511 26.423L14.2749 13.5773H15.5642L25.7276 26.423H24.4511Z" fill="#909090"/>
<path d="M18.1242 20.8358L18.3897 20.5232L18.135 20.2017L12.034 12.5001H16.099L20.1113 17.5714L20.4898 18.0497L20.8846 17.5848L25.1817 12.5238H26.8123L21.5444 18.7354L21.2795 19.0478L21.5336 19.369L27.9668 27.5001H23.9168L19.5598 22.0001L19.181 21.522L18.7865 21.9872L14.1245 27.4844H12.479L18.1242 20.8358ZM24.0592 26.7334L24.2093 26.923H24.4511H25.7276H26.7608L26.1197 26.1127L15.9564 13.267L15.8062 13.0773H15.5642H14.2749H13.241L13.883 13.8877L24.0592 26.7334Z" stroke="black"/>
</g>
<defs>
<filter id="filter0_d_249_388" x="7" y="12.0001" width="26" height="24" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood floodOpacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="4"/>
<feGaussianBlur stdDeviation="2"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_249_388"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_249_388" result="shape"/>
</filter>
</defs>
</svg>

                        </a>
                        <a href="https://T.me/Pondchain" target='_blank' rel="noreferrer" style={{marginLeft:'1rem'}}>
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M26.9593 26.8854L26.9599 26.8837L26.9775 26.8413L30 12.0981V12.0502C30 11.6828 29.8597 11.3621 29.5544 11.1698C29.2872 11.0014 28.98 10.9894 28.7647 11.0052C28.5369 11.022 28.322 11.077 28.1733 11.1228C28.0968 11.1463 28.0328 11.169 27.987 11.1862C27.964 11.1948 27.9454 11.2021 27.9319 11.2076L27.9186 11.213L11.0664 17.6089L11.0618 17.6105C11.0527 17.6137 11.0406 17.6181 11.0261 17.6235C10.9971 17.6344 10.9577 17.6501 10.9113 17.6704C10.8203 17.7103 10.6946 17.7719 10.5671 17.8563C10.3505 17.9998 9.93819 18.3395 10.0078 18.878C10.0655 19.324 10.3833 19.6073 10.5975 19.7539C10.7124 19.8326 10.8223 19.8893 10.9027 19.9263C10.9435 19.9451 10.9781 19.9595 11.0039 19.9696C11.0168 19.9747 11.0277 19.9788 11.036 19.9819L11.0467 19.9857L11.0536 19.9882L14.002 20.9485C13.992 21.1275 14.0104 21.31 14.0594 21.49L15.5363 26.9103C15.7114 27.5529 16.3124 28.0006 16.9993 28.0001C17.6151 27.9997 18.1612 27.6393 18.3932 27.1016L20.699 24.7163L24.6591 27.6537L24.7154 27.6774C25.0752 27.8293 25.4113 27.8775 25.7187 27.8368C26.0256 27.7963 26.2695 27.6718 26.4526 27.53C26.6329 27.3904 26.7565 27.2329 26.8342 27.1144C26.8736 27.0541 26.9031 27.0012 26.9235 26.9613C26.9337 26.9413 26.9418 26.9244 26.9479 26.9112L26.9555 26.8942L26.9582 26.8879L26.9593 26.8854ZM15.5213 21.1172C15.4877 20.994 15.5404 20.8639 15.6516 20.7956L25.6521 14.6514C25.6521 14.6514 26.2403 14.3059 26.2193 14.6514C26.2193 14.6514 26.3243 14.7124 26.0091 14.9968C25.7101 15.267 18.8815 21.6455 18.1905 22.2909C18.1506 22.3282 18.1268 22.3709 18.1127 22.4228L16.9982 26.5374L15.5213 21.1172Z" fill="black"/>
<rect y="0.00012207" width="40" height="40" rx="20" fill="#D9D9D9" fillOpacity="0.14"/>
</svg>



                        </a>
                      </div>
                  </div>
                  <br /> <br />
                  </footer>
      </HashRouter>
    </Suspense>
  )
}
